import { Box } from '@chakra-ui/react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <Box>
      <Header />
      <Box as="main" pt="72px">
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
